import { render, staticRenderFns } from "./BaseSheetHeader.vue?vue&type=template&id=55c7aa40&scoped=true&"
import script from "./BaseSheetHeader.vue?vue&type=script&lang=ts&"
export * from "./BaseSheetHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BaseSheetHeader.vue?vue&type=style&index=0&id=55c7aa40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c7aa40",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardTitle,VIcon,VSpacer})
